/**
 * @generated SignedSource<<c1bc06899cc0cc977aa5e350915c1aa8>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type PracticeResult = "RECURRED" | "TARGETED" | "USED_CORRECTLY" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ProgressViewWindow_learner$data = {
  readonly id: string;
  readonly window: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly fluency: {
          readonly speakingMs: number;
          readonly speechRateWpm: number | null | undefined;
          readonly words: number;
        } | null | undefined;
        readonly id: string;
        readonly practice: ReadonlyArray<{
          readonly item: {
            readonly id: string;
            readonly pattern: string;
          };
          readonly outcome: PracticeResult;
        }>;
        readonly startedAt: any;
      };
    }>;
  };
  readonly " $fragmentType": "ProgressViewWindow_learner";
};
export type ProgressViewWindow_learner$key = {
  readonly " $data"?: ProgressViewWindow_learner$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProgressViewWindow_learner">;
};

import ProgressViewWindowPaginationQuery_graphql from './ProgressViewWindowPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "window"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 100,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "since"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*:: as any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*:: as any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": ProgressViewWindowPaginationQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "ProgressViewWindow_learner",
  "selections": [
    {
      "alias": "window",
      "args": [
        {
          "kind": "Variable",
          "name": "since",
          "variableName": "since"
        },
        {
          "kind": "Literal",
          "name": "spoken",
          "value": true
        }
      ],
      "concreteType": "SessionConnection",
      "kind": "LinkedField",
      "name": "__ProgressView_window_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SessionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Session",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startedAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "SessionFluency",
                  "kind": "LinkedField",
                  "name": "fluency",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "words",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "speakingMs",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "speechRateWpm",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PracticeOutcome",
                  "kind": "LinkedField",
                  "name": "practice",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "outcome",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "PracticeItem",
                      "kind": "LinkedField",
                      "name": "item",
                      "plural": false,
                      "selections": [
                        (v1/*:: as any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "pattern",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v1/*:: as any*/)
  ],
  "type": "Learner",
  "abstractKey": null
};
})();

(node as any).hash = "330cfeb6026bf369835811e4970d667d";

export default node;
